import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from '@/pages/shared/base-query-auth';
import { runMutationOnce, runTableQuery } from '@/pages/shared/rtk-query-helpers';

const postTo = (url) => (model) => ({ url, method: 'POST', body: model });

export const checkerSummaryApi = createApi({
    reducerPath: 'checkerSummaryApi',
    baseQuery: baseQueryWithReauth,
    endpoints: (builder) => ({
        // Every endpoint here is a mutation, including the four lookup lists. They are
        // POST searches whose results are driven by the caller's filter model and must
        // never be served from cache, which is the same reason `getDashboardFilters` is
        // modelled as a mutation rather than a query.
        getTableData: builder.mutation({ query: postTo('/api/checkerSummary/list') }),
        checkDocuments: builder.mutation({ query: postTo('/api/checkerSummary/check') }),
        rejectDocument: builder.mutation({ query: postTo('/api/checkerSummary/reject') }),
        getAuthorList: builder.mutation({ query: postTo('/api/checkerSummary/authors') }),
        getApproversList: builder.mutation({ query: postTo('/api/checkerSummary/approvers') }),
        getSitesList: builder.mutation({ query: postTo('/api/checkerSummary/sites') }),
        getStatusesList: builder.mutation({ query: postTo('/api/checkerSummary/statuses') }),
        getCheckersList: builder.mutation({ query: postTo('/api/checkerSummary/checkers') }),
        reassignCheckers: builder.mutation({
            query: ({ documentCheckers, checkUserId }) => ({
                url: `/api/checkerSummary/reassign/${checkUserId}`,
                method: 'POST',
                body: documentCheckers,
            }),
        }),
    }),
});

/**
 * Runs a `checkerSummaryApi` endpoint once and clears its tracked entry.
 */
export const runCheckerSummaryMutation = (dispatch, endpointName, arg) =>
    runMutationOnce(dispatch, checkerSummaryApi.endpoints[endpointName], arg);

/**
 * Loads the checker summary table, wrapped in the `{ data }` envelope that the shared
 * `getTableData` thunk still expects from a table `request` function.
 */
export const runCheckerSummaryTableQuery = (dispatch, requestData) =>
    runTableQuery(dispatch, checkerSummaryApi.endpoints.getTableData, requestData);

export default checkerSummaryApi;
